import type { PropsWithChildren } from 'react';
import { useEffect, useState } from 'react';

import ReactDOM from 'react-dom'

export interface IPageBadgesProps {}

export const PageBadges = ({
  children,
}: PropsWithChildren<IPageBadgesProps>) => {
  const [pageBadgeContainer, setPageBadgeContainer] =
    useState<Element | null>(null)

  useEffect(() => {
    setPageBadgeContainer(document.querySelector('#page-badge-container'))
  }, [])

  return pageBadgeContainer ? (
    ReactDOM.createPortal(children, pageBadgeContainer)
  ) : (
    <>{children}</>
  )
}

PageBadges.displayName = 'PageBadges'
